import { ChartReaderRoutes } from 'features/chartReader';
import { Navigate, Route, Routes } from 'react-router-dom';

export function HomeRoutes() {
    return (
        <Routes>
            <Route path='/' element={<Navigate to='/chart-reader' replace />} />
            <Route path='/chart-reader/*' element={<ChartReaderRoutes />} />
            <Route path='/*' element={<Navigate to='/chart-reader' replace />} />
        </Routes>
    );
}
